import React, { useEffect, useState } from "react";
import {
  useAddAppToCollectionMutation,
  useFetchAppCollectionsMutation,
  useGetAppCollectionsQuery,
} from "@/features/auth/api/authAPI";
import styles from "./AddToCollectionModal.module.scss";
import { PlusIcon, XIcon } from "lucide-react";
import Loader from "@/shared/ui/Loader/Loader";
import { AppCollection } from "@/features/auth/types/auth";

interface AddToCollectionModalProps {
  isOpen: boolean;
  onClose: () => void;
  appId: number;
}

const AddToCollectionModal: React.FC<AddToCollectionModalProps> = ({
  isOpen,
  onClose,
  appId,
}) => {
  const [fetchAppCollections, { isLoading }] = useFetchAppCollectionsMutation();
  const [addAppToCollection, { isLoading: isAdding }] =
    useAddAppToCollectionMutation();

  const [collections, setCollections] = useState<AppCollection[]>([]);

  useEffect(() => {
    fetchAppCollections().then((res) => {
      setCollections(res.data?.results || []);
    });
  }, []);

  const handleAddAppToCollection = async (collectionId: number) => {
    await addAppToCollection({ id: collectionId, apps: [appId] });
    onClose();
  };

  if (!isOpen) return null;

  const handleModalClick = (e: React.MouseEvent) => {
    e.stopPropagation();
  };

  return (
    <div className={styles.modal} onClick={handleModalClick}>
      <div className={styles.header}>
        <h3>Add to Collection</h3>
        <button className={styles.closeButton} onClick={onClose}>
          <XIcon color="#BABABA" width={16} height={16} />
        </button>
      </div>
      <div className={styles.dividerContainer}>
        <div className={styles.divider} />
      </div>
      <div className={styles.content}>
        <div className={styles.collectionsContainer}>
          {isLoading ? (
            <div className={styles.loading}>
              <Loader />
            </div>
          ) : (
            <>
              {collections?.map((collection) => (
                <div
                  key={collection.id}
                  className={styles.collectionItem}
                  onClick={() => handleAddAppToCollection(collection.id)}
                >
                  <span>{collection.name}</span>
                </div>
              ))}
            </>
          )}
        </div>
        {/* <div className={styles.createNewButtonContainer}>
          <button
            className={styles.createNewButton}
            onClick={() => {}}
            disabled={isAdding}
          >
            <PlusIcon color="#fff" width={16} height={16} />
            <span>Create New Collection</span>
          </button>
        </div> */}
      </div>
    </div>
  );
};

export default AddToCollectionModal;
